// extracted by mini-css-extract-plugin
export default {"editor":"styles_editor__ZnInt","editorReadonly":"styles_editorReadonly__eu59d"};